(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pups-pack-color-family"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('variant-selects input[name^="Size-"], variant-selects select[name="options[Size]"]')) return;

    const picker = event.target.closest('variant-selects');
    if (!picker) return;

    const sizeKey = event.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    picker.querySelectorAll('[data-sibling-color]').forEach((link) => {
      const nextUrl = link.dataset[`size${sizeKey.charAt(0).toUpperCase()}${sizeKey.slice(1)}`];
      if (nextUrl) link.href = nextUrl;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pups-pack-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share-control')) {
    customElements.define(
      'product-share-control',
      class ProductShareControl extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.status = this.querySelector('[role="status"]');
          this.button.addEventListener('click', this.share.bind(this));
        }

        async share() {
          const shareData = {
            title: this.dataset.shareTitle,
            url: this.dataset.shareUrl,
          };

          if (navigator.share) {
            try {
              await navigator.share(shareData);
            } catch (error) {
              if (error.name !== 'AbortError') {
                await this.copyLink();
              }
            }
            return;
          }

          await this.copyLink();
        }

        async copyLink() {
          await navigator.clipboard.writeText(this.dataset.shareUrl);
          this.status.textContent = window.accessibilityStrings.shareSuccess;
          window.setTimeout(() => {
            this.status.textContent = '';
          }, 2500);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
